// extracted by mini-css-extract-plugin
export var background = "styles-module--background--2ZWnn";
export var container = "styles-module--container--3RmGe";
export var section = "styles-module--section--nRVir";
export var video = "styles-module--video--dkDDY";
export var sectionMain = "styles-module--sectionMain--3yuzk";